import Contact from './Contact';
import Home from './Home';
import Experiments from './Experiments';
import NotFound from './NotFound';
import Services from './Services';
import PrivacyPolicy from './PrivacyPolicy';

export { Contact, Home, Experiments, NotFound, Services, PrivacyPolicy };
